const topics = [
  { label: '恋爱韩漫', icon: 'ri-heart-line', color: 'accent', desc: '甜蜜浪漫爱情故事' },
  { label: '奇幻韩漫', icon: 'ri-magic-line', color: 'primary', desc: '异世界冒险史诗' },
  { label: '悬疑韩漫', icon: 'ri-search-eye-line', color: 'secondary', desc: '烧脑推理逆转' },
  { label: '动作韩漫', icon: 'ri-swap-box-line', color: 'accent', desc: '热血格斗激战' },
  { label: '校园韩漫', icon: 'ri-building-2-line', color: 'primary', desc: '青春校园日常' },
  { label: '古风韩漫', icon: 'ri-ancient-gate-line', color: 'secondary', desc: '朝鲜时代传奇' },
  { label: '都市韩漫', icon: 'ri-building-line', color: 'accent', desc: '现代职场人生' },
  { label: '新番推荐', icon: 'ri-fire-line', color: 'primary', desc: '最新上架连载' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按题材分类浏览，快速找到你喜欢的韩漫类型，总有一部合你口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer no-underline"
            >
              <span
                className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${colorMap[topic.color]} flex items-center justify-center`}
              >
                <i className={`${topic.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed">
                {topic.desc}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}